import React from 'react';

export type TemplateGallerySettings = {
    getTemplateHref?: (templateId: string) => string;
};

const TemplateGalleryContext = React.createContext<TemplateGallerySettings>({});

export const TemplateGalleryProvider = TemplateGalleryContext.Provider;

export function useTemplateGallerySettings(): TemplateGallerySettings {
    return React.useContext(TemplateGalleryContext);
}
